export class PaymentFederalTaxesEventType {

	static STEPS = {
		PAYMENT_SELECT_STEP: 'PAYMENT_SELECT_STEP',
		PAYMENT_GPS_STEP: 'PAYMENT_GPS_STEP',
		PAYMENT_DARF_STEP: 'PAYMENT_DARF_STEP'
	};

	static STEPS_DARF = {
		PAYMENT_DARF: 'PAYMENT_DARF',
		CONFIRM_DARF: 'CONFIRM_DARF',
		RESULT_DARF: 'RESULT_DARF'
	};
	static SEND_DARF = {
		PAYMENT_DARF_SEND: 'PAYMENT_DARF_SEND',
		PAYMENT_DARF_CONFIRM: 'PAYMENT_DARF_CONFIRM'
	};

	static MODAL = {
		TRUE_MODAL: 'TRUE_MODAL'
	};

	static STEPS_GPS = {
		PAYMENT_GPS: 'PAYMENT_GPS',
		CONFIRM_GPS: 'CONFIRM_GPS',
		RESULT_GPS: 'RESULT_GPS'
	};
	static SEND_GPS = {
		PAYMENT_GPS_SEND: 'PAYMENT_GPS_SEND',
		PAYMENT_GPS_CONFIRM: 'PAYMENT_GPS_CONFIRM'
	};

	static ERROR = 'PAYMENT_ERROR';
	static BUTTONS = 'PAYMENT_BUTTONS';
	static PAYMENT_FEDERAL_TAXES_SEND = 'PAYMENT_FEDERAL_TAXES_SEND';

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/payment-federal-taxes/payment-federal-taxes.event.type.ts